export default __webpack_public_path__ + "media/zurb/img/about/culture/culture-img9-541911275e50dad525bd9950159e59ba.png";